import { render, staticRenderFns } from "./DocumentationItems.vue?vue&type=template&id=0f6ac309&scoped=true&"
import script from "./DocumentationItems.vue?vue&type=script&lang=js&"
export * from "./DocumentationItems.vue?vue&type=script&lang=js&"
import style0 from "./DocumentationItems.vue?vue&type=style&index=0&id=0f6ac309&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6ac309",
  null
  
)

export default component.exports